<template>
    <div class="file-manage">
        <input
                @input="handleFileInput($event)"
                type="file"
                :ref="fileInputRef"
                class="d-none"
                :accept="accept"
        >
        <b-button
                v-if="!file.exists && showAddButton"
                variant="light"
                size="lg"
                class="btn-add-file"
                :disabled="disabled || loading"
                @click="$refs[fileInputRef].click()"
        >
            {{addText}}
        </b-button>
        <div
                id="file-details-tooltip"
                class="file-details"
                v-if="file.exists"
        >
            <file-resource-thumbnail :file-app-resource="file" />
            <span class="file-title text-truncate">
                {{ file.fileTitle }}
            </span>
            <i
                    class="fas fa-times-circle ml-auto text-gray-700 cursor-pointer"
                    @click="handleClickRemove()"
            />
        </div>
        <b-tooltip
                v-if="tooltipMessage && file.exists"
                show
                target="file-details-tooltip"
                placement="top"
        >
            {{tooltipMessage}}
        </b-tooltip>
    </div>
</template>

<script>
    import './FileManage.scss';
    import FileAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/FileAppResource";
    import FileResourceThumbnail from "../../DragAndDropResource/FileResourceThumbnail/FileResourceThumbnail.vue";
    import {generateRandomString} from "../../../helpers/stringHelpers";
    import ShowNotificationMixin from "../../../mixins/ShowNotificationMixin";

    export default {
        name: "FileManage",

        components: {
            FileResourceThumbnail
        },
        mixins: [
            ShowNotificationMixin
        ],
        props: {
            value: {
                type: String,
                default: ''
            },
            accept: {
                type: [Array, String],
                default: '*'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            tooltipMessage: {
                type: String,
                default: ''
            },
            addText: {
                type: String,
                default: '+ Add File'
            },
            showAddButton: {
                type: Boolean,
                default: true
            },

        },
        data() {
            return {
                file: new FileAppResource(),
                internalModel: this.value,
                loading: false,
            };
        },
        computed: {
            fileInputRef() {
                return generateRandomString(32);
            },
        },
        methods: {
            async fetchFile(uuid) {
                if (!uuid) {
                    this.file = new FileAppResource();
                    return;
                }
                let file = new FileAppResource({
                    uuid: uuid
                });

                this.loading = true;
                try {
                    await file.fetch();
                    this.file = file.exists ? file : new FileAppResource();
                } catch (e) {
                    console.warn(e);
                    this.showNotification({
                        message: 'File could not be loaded. Please try again later.',
                        type: 'error',
                    });
                } finally {
                    this.loading = false;
                }
            },
            handleFileInput(event) {
                if (!event.target.files.length) {
                    return;
                }
                try {
                    this.loading = true;
                    let fileAppResource = new FileAppResource();
                    fileAppResource.setAttribute('file', event.target.files[0]);
                    fileAppResource.save(false, false);
                    fileAppResource.once('saved', () => {
                        this.showNotification({
                            message: 'File uploaded successfully!',
                            type: 'success',
                        });

                        this.file = fileAppResource;
                        this.internalModel = fileAppResource.uuid;

                    });

                } catch (e) {
                    console.warn(e);
                    this.showNotification({
                        message: 'File could not be uploaded. Please try again later.',
                        type: 'error',
                    });
                } finally {
                    this.loading = false;
                }

            },
            handleClickRemove() {
                if (this.disabled || this.loading) {
                    return;
                }
                this.internalModel = '';
            }
        },
        watch: {
            async internalModel(newVal, oldVal) {
                await this.fetchFile(newVal);
                if (newVal !== oldVal) {
                    this.$emit('input', newVal);
                }
            },
            value(newVal) {
                this.internalModel = newVal;
            },
        },
        async mounted() {
            await this.fetchFile(this.value);
        }
    };
</script>